module.exports = __webpack_public_path__ + "media/assets/images/landing/безопасность-16686637a45677e732c696194757c7d8.png";